export const products: any[] = [];
